import { useTranslation } from "react-i18next";
import { useOrdersList } from "../../context/OrderListContext";
import OrdersListFilters from "../OrdersListFilters/OrdersListFilters";

export default function OrdersListHeader() {
  const { t } = useTranslation();
  const { selectedTab } = useOrdersList();

  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div className="flex flex-col gap-1">
        <div className="text-font-default text-2xl font-semibold">{t(`UserHistory.ordersList.header.${selectedTab}.title`)}</div>
        <div className="text-font-subtle text-sm">{t(`UserHistory.ordersList.header.${selectedTab}.subtitle`)}</div>
      </div>
      <div className="w-full md:w-80">
        <OrdersListFilters />
      </div>
    </div>
  );
}
